// extracted by mini-css-extract-plugin
export default {"content":"Table_content__2Rivg","header":"Table_header__Zc9u-","body":"Table_body__MWWeH","truncate":"Table_truncate__IbcDT","active":"Table_active__o2xsD"};